webpackJsonp([1],{

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png";

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(315);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_2__App___default.a
  }
});

/***/ }),

/***/ 312:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hopscotch__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hopscotch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hopscotch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(72);










/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      searchFilters: {
        company: null,
        area: null,
        agent: null,
        dls: null,
        date: null
      },

      layerFilters: ['asset_type=\'Royalty\'', 'asset_type=\'Land\'', 'asset_type=\'Production\''],

      drawer: false,

      dateDialog: false,
      startDateMenu: false,
      endDateMenu: false,
      startDate: null,
      endDate: null,

      listDialog: false,
      listSearch: '',
      listPagination: {},
      listDataTableHeaders: [{
        text: 'Area',
        value: 'area',
        align: 'left'
      }, {
        text: 'Asset Type',
        value: 'asset_type',
        align: 'left'
      }, {
        text: 'Company',
        value: 'company',
        align: 'left'
      }, {
        text: 'Advisor',
        value: 'agent',
        align: 'left'
      }, {
        text: 'Bid Date',
        value: 'bid_date',
        align: 'left'
      }, {
        text: 'Description',
        value: 'description',
        align: 'left',
        sortable: false
      }],

      snackbarY: 'bottom',
      snackbarX: 'center',
      snackbarMode: 'multi-line',

      assetManager: true,
      royaltyLayer: true,
      productionLayer: true,
      landLayer: true,
      pipelineLayer: true,
      facilitiesLayer: null,
      gridLayer: true,

      serverUrl: __WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].serverUrl,
      isOpen: false,
      hasResults: false,
      keyword: null,
      searchResult: [],
      selectedItem: null,
      geom: '',

      tagCompany: false,
      selectedCompany: null,
      tagArea: false,
      selectedArea: null,
      tagAdvisor: false,
      selectedAdvisor: null,
      tagDate: false,
      selectedDate: null,

      inTour: false
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* mapActions */])(['loadAssetsLayer', 'updateTownshipHighlightLayer']), {
    onInput: function onInput(value) {
      this.isOpen = !!value;

      var wfsParams = {
        service: 'WFS',
        version: '2.0.0',
        request: 'GetFeature',
        typeName: 'jwn:search_autocomplete',
        outputFormat: 'application/json',
        srsname: 'EPSG:4326',
        viewparams: 'query:' + this.keyword
      };

      if (this.keyword !== null && this.keyword !== '') {

        var app = this;
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(app.serverUrl, {
          params: wfsParams
        }).then(function (response) {
          var data = response.data;
          app.searchResult = [];
          for (var i = 0; i < data.features.length; i++) {
            var icon = "";
            switch (data.features[i].properties.column) {
              case "company":
                icon = "business";
                break;
              case "dls":
                icon = "place";
                break;
              case "area":
                icon = "select_all";
                break;
              case "agent":
                icon = "person";
                break;
            }

            app.searchResult.push({
              value: data.features[i].properties.search_term,
              table: data.features[i].properties.table,
              column: data.features[i].properties.column,
              geom: data.features[i].geometry,
              icon: icon
            });
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    select: function select(index) {
      this.searchFilters["dls"] = null;

      this.selectedItem = this.filteredItems[index];
      this.keyword = this.selectedItem.value;
      this.geom = this.selectedItem.geom;
      var table = this.selectedItem.table;
      var column = this.selectedItem.column;
      var filter = column + "='" + this.keyword + "'";
      this.searchFilters[column] = filter;

      if (table === "dlsgrids") {
        this.$store.commit("updateDlsLayer", this.geom);
      } else {
        this.filterAssetLayer();
      }

      this.isOpen = false;
      this.keyword = null;

      switch (column) {
        case "company":
          this.tagCompany = true;
          this.selectedCompany = this.selectedItem.value;
          break;
        case "area":
          this.tagArea = true;
          this.selectedArea = this.selectedItem.value;
          break;
        case "agent":
          this.tagAdvisor = true;
          this.selectedAdvisor = this.selectedItem.value;
          break;
      }
    },
    removeTag: function removeTag(tag) {
      this.searchFilters[tag] = null;
      if (tag === 'date') {
        this.startDate = null;
        this.endDate = null;
      }
      this.filterAssetLayer();
      this.selectedItem = null;
    },
    filterByDate: function filterByDate() {
      this.searchFilters["dls"] = null;

      this.$store.state.map.removeLayer(this.assetsLayer);

      var filter = 'bid_date > \'' + this.startDate + '\' AND bid_date < \'' + this.endDate + '\'';
      this.searchFilters["date"] = filter;

      this.tagDate = true;
      this.selectedDate = this.startDate + ' - ' + this.endDate;

      this.filterAssetLayer();
    },
    closeSnackbar: function closeSnackbar() {
      this.$store.state.snackbar = false;
    },
    filterAssetLayer: function filterAssetLayer() {
      var _filters = [];
      __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.forEach(this.searchFilters, function (value, key) {
        value !== null && _filters.push(value);
      });

      var filters = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(this.layerFilters, ' OR ');
      if (_filters.length > 0) {
        filters = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.join(_filters, ' AND ') + ' AND (' + filters + ')';
      }

      this.$store.state.map.removeLayer(this.assetsLayer);

      this.townshipHighlightLayer !== null && this.$store.state.map.removeLayer(this.townshipHighlightLayer) && this.updateTownshipHighlightLayer(null);

      if (this.layerFilters.length > 0) {
        if (filters !== '') {
          this.loadAssetsLayer(filters);
        } else {
          this.loadAssetsLayer(null);
        }
      }
    },
    filterByThisQuarter: function filterByThisQuarter() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() < 10 ? '0' + currentDate.getMonth() : currentDate.getMonth();
      var currentDay = currentDate.getDay() < 10 ? '0' + currentDate.getDay() : currentDate.getDay();
      this.endDate = currentYear + '-' + currentMonth + '-' + currentDay;

      if (currentMonth >= 1 & currentMonth <= 3) {
        this.startDate = currentYear + '-01-01';
      } else if (currentMonth >= 4 & currentMonth <= 6) {
        this.startDate = currentYear + '-03-01';
      } else if (currentMonth >= 7 & currentMonth <= 9) {
        this.startDate = currentYear + '-06-01';
      } else if (currentMonth >= 10 & currentMonth <= 12) {
        this.startDate = currentYear + '-09-01';
      }
      this.filterByDate();
    },
    filterByLastQuarter: function filterByLastQuarter() {
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() < 10 ? '0' + currentDate.getMonth() : currentDate.getMonth();
      var currentDay = currentDate.getDay() < 10 ? '0' + currentDate.getDay() : currentDate.getDay();

      if (currentMonth >= 1 & currentMonth <= 3) {
        this.startDate = currentYear - 1 + '-10-01';
        this.endDate = currentYear - 1 + '-12-31';
      } else if (currentMonth >= 4 & currentMonth <= 6) {
        this.startDate = currentYear + '-01-01';
        this.endDate = currentYear + '-03-31';
      } else if (currentMonth >= 7 & currentMonth <= 9) {
        this.startDate = currentYear + '-04-01';
        this.endDate = currentYear + '-06-30';
      } else if (currentMonth >= 10 & currentMonth <= 12) {
        this.startDate = currentYear + '-07-01';
        this.endDate = currentYear + '-09-30';
      }
      this.filterByDate();
    },
    tour: function tour() {
      var _this = this;

      var tour = {
        id: "assets-for-sale-tour",
        steps: [{
          title: "Menu",
          content: "Select the menu to turn layers on and off, take a tour, and get help.",
          target: document.querySelector(".app-menu-icon"),
          placement: "bottom",
          showCTAButton: true,
          ctaLabel: 'Open Menu',
          onCTA: function onCTA() {
            _this.drawer = true;
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.nextStep();
            }, 250);
          },
          onNext: function onNext() {
            if (!_this.drawer) {
              __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(2);
            }
          }
        }, {
          title: "Menu Items",
          content: "Turn on/off layers.",
          target: document.querySelector(".app-menu-item"),
          placement: "right",
          onNext: function onNext() {
            _this.drawer = false;
          },
          onPrev: function onPrev() {
            _this.drawer = false;
          }
        }, {
          title: "Search Box",
          content: "Assets can be keyword searched using the search bar.",
          target: document.querySelector(".app-search-box"),
          placement: "bottom",
          onPrev: function onPrev() {
            __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(0);
          },
          showCTAButton: true,
          ctaLabel: 'Perform a Search',
          onCTA: function onCTA() {
            _this.keyword = 'd';
            _this.onInput(_this.keyword);
            setTimeout(function () {
              __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.nextStep();
            }, 350);
          },
          onNext: function onNext() {
            if (_this.keyword === null || _this.keyword === '') {
              __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(5);
            }
          }
        }, {
          title: "Search Results",
          content: 'Select any of the items in the search results.<br /><i class="material-icons">business</i> Comany | <i class="material-icons">select_all</i> Area | <i class="material-icons">person</i> Advisor',
          target: document.querySelector(".autocomplete-list"),
          placement: "right",
          onPrev: function onPrev() {
            _this.keyword = null;
            _this.searchResult = [];
            _this.isOpen = false;
          },
          onNext: function onNext() {
            _this.keyword = null;
            _this.searchResult = [];
            _this.isOpen = false;
            __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(5);
          }
        }, {
          title: "Search Tags & Pins",
          content: 'This is the filter you just applied! Filters can be removed by selecting the <i class="material-icons">close</i> next to the filtered term.<br />You can now click on a map pin to drill down into the data.',
          target: document.querySelector(".app-search-tags"),
          placement: "bottom",
          onPrev: function onPrev() {
            _this.tagCompany = false;
            _this.tagAdvisor = false;
            _this.tagArea = false;
            _this.tagDate = false;
            __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(2);
          }
        }, {
          title: "Temporal Filter",
          content: "Assets can also be filtered by time.",
          target: document.querySelector(".app-date-filter"),
          placement: "bottom",
          onPrev: function onPrev() {
            __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(2);
          }
        }, {
          title: "Table View",
          content: "The data can be viewed in a table.",
          target: document.querySelector(".app-table-view"),
          placement: "bottom"
        }],
        showPrevButton: true,
        onStart: function onStart() {
          _this.inTour = true;
        },
        onClose: function onClose() {
          _this.inTour = false;
        },
        onEnd: function onEnd() {
          _this.inTour = false;
        }
      };

      __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.startTour(tour, 0);

      localStorage.setItem('first_time_visitor', true);
    }
  }),
  computed: {
    filteredItems: function filteredItems() {
      if (this.searchResult.length > 0) {
        this.hasResults = true;
      } else {
        this.hasResults = false;
      }
      return this.searchResult;
    },
    assetData: function assetData() {
      return this.$store.state.assetData;
    },
    assetsLayer: function assetsLayer() {
      return this.$store.state.assetsLayer;
    },
    snackbar: function snackbar() {
      return this.$store.state.snackbar;
    },
    snackbarContext: function snackbarContext() {
      return this.$store.state.snackbarContext;
    },
    snackbarTimeout: function snackbarTimeout() {
      return this.$store.state.snackbarTimeout;
    },
    snackbarText: function snackbarText() {
      return this.$store.state.snackbarText;
    },
    townshipHighlightLayer: function townshipHighlightLayer() {
      return this.$store.state.townshipHighlightLayer;
    }
  },
  watch: {
    selectedItem: function selectedItem() {
      if (this.selectedItem !== null && this.inTour === true) {
        setTimeout(function () {
          __WEBPACK_IMPORTED_MODULE_3_hopscotch___default.a.showStep(4);
        }, 350);
      }
    },
    assetManager: function assetManager() {
      this.$store.commit('updateAssetManager', this.assetManager);
    },
    royaltyLayer: function royaltyLayer() {
      if (this.royaltyLayer) {
        this.layerFilters.push('asset_type=\'Royalty\'');
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf('asset_type=\'Royalty\''), 1);
      }
      this.filterAssetLayer();
    },
    landLayer: function landLayer() {
      if (this.landLayer) {
        this.layerFilters.push('asset_type=\'Land\'');
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf('asset_type=\'Land\''), 1);
      }
      this.filterAssetLayer();
    },
    productionLayer: function productionLayer() {
      if (this.productionLayer) {
        this.layerFilters.push('asset_type=\'Production\'');
      } else {
        this.layerFilters.splice(this.layerFilters.indexOf('asset_type=\'Production\''), 1);
      }
      this.filterAssetLayer();
    },
    pipelineLayer: function pipelineLayer() {
      this.$store.commit('updatePipelineLayer', this.pipelineLayer);
    },
    gridLayer: function gridLayer() {
      this.$store.commit('updateGridLayer', this.gridLayer);
    },
    tagCompany: function tagCompany() {
      if (!this.tagCompany) {
        this.removeTag('company');
      }
    },
    tagArea: function tagArea() {
      if (!this.tagArea) {
        this.removeTag('area');
      }
    },
    tagAdvisor: function tagAdvisor() {
      if (!this.tagAdvisor) {
        this.removeTag('agent');
      }
    },
    tagDate: function tagDate() {
      if (!this.tagDate) {
        this.removeTag('date');
      }
    }
  },

  mounted: function mounted() {
    this.$store.commit('updateAssetManager', this.assetManager);
    this.$store.commit('updatePipelineLayer', this.pipelineLayer);
    this.$store.commit('updateGridLayer', this.gridLayer);
    if (!localStorage.getItem('first_time_visitor')) {
      this.tour();
    }
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_esri_leaflet__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_esri_leaflet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_esri_leaflet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_markercluster__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_leaflet_markercluster___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_leaflet_markercluster__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config__ = __webpack_require__(72);











var mapMaxZoom = 20;
var mapDetectRetina = true;
var mapCenter = [55, -114];
var mapInitialZoom = 6;
var mapZoomControl = false;

var tileFormat = "image/png";
var tileTransparent = true;
var tileTiled = true;
var tileOpacity = 0.5;

var gridLayer = null;

var cartoLight = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {
  maxZoom: mapMaxZoom,
  detectRetina: mapDetectRetina,
  attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attribution">CARTO</a>'
});

var pipelineLayer = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].pipelineLayerUrl, {
  tiled: tileTiled,
  opacity: tileOpacity,
  transparent: tileTransparent
});

var provinceLayer = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.tileLayer(__WEBPACK_IMPORTED_MODULE_6__config__["a" /* config */].provinceLayerUrl, {
  tiled: tileTiled,
  opacity: tileOpacity,
  transparent: tileTransparent
});

var dlsGridLayer = __WEBPACK_IMPORTED_MODULE_2_esri_leaflet___default.a.dynamicMapLayer({
  url: 'https://mapping.geologic.com/arcgis/rest/services/EE_PROD/EE_CanadaGrids/MapServer',
  proxy: 'https://secure.junewarren-nickles.com/arcgis/proxy.ashx',
  opacity: 1
});

var logo = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.control({
  position: 'bottomleft'
});

logo.onAdd = function (map) {
  var div = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.DomUtil.create('div', 'logo');
  var logo = __webpack_require__(290);
  div.innerHTML = '<a href="https://www.dobenergy.com/" target="_blank"><img class="logo" src="' + logo + '" /></a>';
  return div;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapActions */])(['loadAssetsLayer', 'updateTownshipHighlightLayer'])),
  computed: {
    map: function map() {
      return this.$store.state.map;
    },
    assetManager: function assetManager() {
      return this.$store.state.assetManager;
    },
    assetsLayer: function assetsLayer() {
      return this.$store.state.assetsLayer;
    },
    dlsLayer: function dlsLayer() {
      return this.$store.state.dlsLayer;
    },
    pipelineLayer: function pipelineLayer() {
      return this.$store.state.pipelineLayer;
    },
    gridLayer: function gridLayer() {
      return this.$store.state.gridLayer;
    },
    townshipHighlightLayer: function townshipHighlightLayer() {
      return this.$store.state.townshipHighlightLayer;
    }
  },

  mounted: function mounted() {
    var map = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.map("map", {
      center: mapCenter,
      zoom: mapInitialZoom,
      zoomControl: mapZoomControl
    });

    __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.control.zoom({
      position: 'bottomright'
    }).addTo(map);

    this.$store.commit('updateMap', map);

    cartoLight.addTo(map);

    logo.addTo(map);

    provinceLayer.addTo(map);

    this.loadAssetsLayer(null);

    map.attributionControl.addAttribution('Asset data &copy; <a href="http://www.canoils.com/" target="_blank">CanOils</a>');
  },
  updated: function updated() {
    var _this = this;

    this.$nextTick(function () {

      if (_this.assetManager) {
        _this.map !== null && _this.assetsLayer !== null && _this.map.addLayer(_this.assetsLayer);
      } else {
        _this.map.removeLayer(_this.assetsLayer);
      }

      if (_this.townshipHighlightLayer !== null) {
        _this.map.addLayer(_this.townshipHighlightLayer);
        _this.map.fitBounds(_this.townshipHighlightLayer.getBounds());
      }

      if (_this.dlsLayer !== null) {
        _this.map.hasLayer(_this.dlsLayer) && _this.map.removeLayer(_this.dlsLayer);
        var _dlsLayer = __WEBPACK_IMPORTED_MODULE_1_leaflet___default.a.geoJSON(_this.dlsLayer, {
          style: {
            fillOpacity: 0.5,
            fillColor: '#bdbdbd',
            color: '#bdbdbd',
            weight: 1
          }
        });

        _this.map.addLayer(_dlsLayer);
        _this.map.fitBounds(_dlsLayer.getBounds());

        setTimeout(function () {
          _this.map.removeLayer(_dlsLayer);
          _this.$store.commit('updateDlsLayer', null);
        }, 2000);
      }

      if (_this.pipelineLayer) {
        pipelineLayer.addTo(_this.map);
      } else {
        _this.map.removeLayer(pipelineLayer);
      }

      if (_this.gridLayer) {
        dlsGridLayer !== null && dlsGridLayer.addTo(_this.map);
      } else {
        _this.map.removeLayer(dlsGridLayer);
      }
    });
  }
});

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Map__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    components: {
      'Map': __WEBPACK_IMPORTED_MODULE_2__components_Map___default.a
    }
  }]
}));

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(72);







__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */]);

var iconSize = [50, 50];
var iconAnchor = [10, 27];
var iconPopupAnchor = [16, -24];

var clusterIconSize = new L.Point(40, 40);
var clusterShowCoverageOnHover = false;

var iconLand = L.icon({
  iconUrl: __webpack_require__(540),
  iconSize: iconSize,
  iconAnchor: iconAnchor,
  popupAnchor: iconPopupAnchor
});

var iconProduction = L.icon({
  iconUrl: __webpack_require__(541),
  iconSize: iconSize,
  iconAnchor: iconAnchor,
  popupAnchor: iconPopupAnchor
});

var iconRoyalty = L.icon({
  iconUrl: __webpack_require__(542),
  iconSize: iconSize,
  iconAnchor: iconAnchor,
  popupAnchor: iconPopupAnchor
});

var state = {
  map: null,
  totalFeatures: 0,
  assetData: [],
  snackbar: false,
  snackbarContext: '',
  snackbarTimeout: 6000,
  snackbarText: '',
  assetManager: null,
  assetsLayer: null,
  pipelineLayer: null,
  gridLayer: null,
  dlsLayer: null,
  townshipHighlightLayer: null
};

var mutations = {
  updateMap: function updateMap(state, feature) {
    state.map = feature;
  },
  updateAssetManager: function updateAssetManager(state, feature) {
    state.assetManager = feature;
  },
  loadAssetsLayer: function loadAssetsLayer(state, feature) {
    state.assetsLayer = feature;
    if (state.totalFeatures > 0) {
      state.map.fitBounds(feature.getBounds());
      state.snackbarContext = 'success';
      var _asset = state.totalFeatures > 9 ? 'assets' : 'asset';
      state.snackbarText = state.totalFeatures + ' ' + _asset + ' were retrieved.';
      state.snackbar = true;
      setTimeout(function () {
        state.snackbar = false;
      }, state.snackbarTimeout);
    } else {
      state.snackbarContext = 'error';
      state.snackbarText = 'No assets were found. Try different filters perhaps.';
      state.snackbar = true;
      setTimeout(function () {
        state.snackbar = false;
      }, state.snackbarTimeout);
    }
  },
  updatePipelineLayer: function updatePipelineLayer(state, feature) {
    state.pipelineLayer = feature;
  },
  updateGridLayer: function updateGridLayer(state, feature) {
    state.gridLayer = feature;
  },
  updateDlsLayer: function updateDlsLayer(state, feature) {
    state.dlsLayer = feature;
  },
  updateTownshipHighlightLayer: function updateTownshipHighlightLayer(state, feature) {
    state.townshipHighlightLayer = feature;
  }
};

var actions = {
  updateTownshipHighlightLayer: function updateTownshipHighlightLayer(_ref, feature) {
    var commit = _ref.commit;

    commit('updateTownshipHighlightLayer', feature);
  },
  loadAssetsLayer: function loadAssetsLayer(_ref2, filter) {
    var commit = _ref2.commit,
        state = _ref2.state;


    var wfsParams = {
      service: 'WFS',
      version: '2.0.0',
      request: 'GetFeature',
      typeName: 'jwn:assets',
      outputFormat: 'application/json',
      srsname: 'EPSG:4326'
    };

    if (filter !== null) {
      wfsParams.cql_filter = filter;
    }

    var icons = {
      'Land': iconLand,
      'Production': iconProduction,
      'Royalty': iconRoyalty
    };

    var highlights = {
      'Land': '#85a800',
      'Production': '#ef5534',
      'Royalty': '#0085b1'
    };

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.withCredentials = true;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].serverUrl, {
      params: wfsParams
    }).then(function (response) {
      state.totalFeatures = response.data.totalFeatures;
      state.assetData = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(response.data.features), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var feature = _step.value;

          state.assetData.push({
            area: feature.properties.area,
            asset_type: feature.properties.asset_type,
            company: feature.properties.company,
            bid_date: feature.properties.bid_date !== null ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(feature.properties.bid_date).format('YYYY-MM-DD HH:mm:ss') : null,
            agent: feature.properties.agent,
            description: feature.properties.description
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _assets = [];

      var _loop = function _loop(asset) {
        var marker = L.geoJson(response.data, {
          filter: function filter(feature, layer) {
            return feature.properties.asset_type === asset;
          },
          pointToLayer: function pointToLayer(feature, latlng) {
            return L.marker(latlng, {
              icon: icons[feature.properties.asset_type]
            });
          },
          onEachFeature: function onEachFeature(feature, layer) {
            if (feature.properties) {
              layer.bindPopup('<div class="app-popup">\n                                    <table>\n                                      <tr>\n                                        <th>Area</th>\n                                        <td>' + feature.properties.area + '</td>\n                                      </tr>\n                                      <tr>\n                                        <th>Asset Type</th>\n                                        <td>' + feature.properties.asset_type + '</td>\n                                      </tr>\n                                      <tr>\n                                        <th>Advisor</th>\n                                        <td>' + feature.properties.agent + '</td>\n                                      </tr>\n                                      <tr>\n                                        <th>Bid Date</th>\n                                        <td>' + (feature.properties.bid_date !== null ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(feature.properties.bid_date).format('YYYY-MM-DD HH:mm:ss') : null) + '</td>\n                                      </tr>\n                                      <tr>\n                                        <th>Description</th>\n                                        <td>' + feature.properties.description + '</td>\n                                      </tr>\n                                    </table>\n                                    <br/>\n                                    Note: The pin represents an average of all locations. Individual locations are highlighted.\n                                </div>');
            }
            layer.on({
              click: function click(e) {
                var areaId = feature.properties.area_id;
                var wfsParams = {
                  service: 'WFS',
                  version: '2.0.0',
                  request: 'GetFeature',
                  typeName: 'jwn:townships',
                  outputFormat: 'application/json',
                  srsname: 'EPSG:4326',
                  cql_filter: 'area_id=' + areaId
                };
                __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__config__["a" /* config */].serverUrl, {
                  params: wfsParams
                }).then(function (response) {
                  state.map.hasLayer(state.townshipHighlightLayer) && state.map.removeLayer(state.townshipHighlightLayer);
                  if (response.data.totalFeatures > 0) {
                    commit('updateTownshipHighlightLayer', L.geoJSON(response.data, {
                      style: {
                        fillOpacity: 0.5,
                        fillColor: highlights[feature.properties.asset_type],
                        color: highlights[feature.properties.asset_type],
                        weight: 1
                      },
                      onEachFeature: function onEachFeature(feature, layer) {
                        if (feature.properties) {
                          layer.bindPopup(feature.properties.dls_location);
                        }
                      }
                    }));
                  }
                }).catch(function (error) {
                  console.log(error);
                });
              }
            });
          }
        });
        var markerCluster = L.markerClusterGroup({
          iconCreateFunction: function iconCreateFunction(cluster) {
            var childCount = cluster.getChildCount();
            return new L.DivIcon({
              html: '<div><span>' + childCount + '</span></div>',
              className: 'marker-cluster marker-cluster-small ' + asset.toLowerCase(),
              iconSize: clusterIconSize
            });
          },
          showCoverageOnHover: clusterShowCoverageOnHover
        });
        markerCluster.addLayer(marker);
        _assets.push(markerCluster);
      };

      var _arr = ['Land', 'Production', 'Royalty'];
      for (var _i = 0; _i < _arr.length; _i++) {
        var asset = _arr[_i];
        _loop(asset);
      }
      commit('loadAssetsLayer', L.featureGroup(_assets));
    }).catch(function (error) {
      console.log(error);
    });
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* default */].Store({
  state: state,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 530:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 531:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 532:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 155,
	"./af.js": 155,
	"./ar": 162,
	"./ar-dz": 156,
	"./ar-dz.js": 156,
	"./ar-kw": 157,
	"./ar-kw.js": 157,
	"./ar-ly": 158,
	"./ar-ly.js": 158,
	"./ar-ma": 159,
	"./ar-ma.js": 159,
	"./ar-sa": 160,
	"./ar-sa.js": 160,
	"./ar-tn": 161,
	"./ar-tn.js": 161,
	"./ar.js": 162,
	"./az": 163,
	"./az.js": 163,
	"./be": 164,
	"./be.js": 164,
	"./bg": 165,
	"./bg.js": 165,
	"./bm": 166,
	"./bm.js": 166,
	"./bn": 168,
	"./bn-bd": 167,
	"./bn-bd.js": 167,
	"./bn.js": 168,
	"./bo": 169,
	"./bo.js": 169,
	"./br": 170,
	"./br.js": 170,
	"./bs": 171,
	"./bs.js": 171,
	"./ca": 172,
	"./ca.js": 172,
	"./cs": 173,
	"./cs.js": 173,
	"./cv": 174,
	"./cv.js": 174,
	"./cy": 175,
	"./cy.js": 175,
	"./da": 176,
	"./da.js": 176,
	"./de": 179,
	"./de-at": 177,
	"./de-at.js": 177,
	"./de-ch": 178,
	"./de-ch.js": 178,
	"./de.js": 179,
	"./dv": 180,
	"./dv.js": 180,
	"./el": 181,
	"./el.js": 181,
	"./en-au": 182,
	"./en-au.js": 182,
	"./en-ca": 183,
	"./en-ca.js": 183,
	"./en-gb": 184,
	"./en-gb.js": 184,
	"./en-ie": 185,
	"./en-ie.js": 185,
	"./en-il": 186,
	"./en-il.js": 186,
	"./en-in": 187,
	"./en-in.js": 187,
	"./en-nz": 188,
	"./en-nz.js": 188,
	"./en-sg": 189,
	"./en-sg.js": 189,
	"./eo": 190,
	"./eo.js": 190,
	"./es": 194,
	"./es-do": 191,
	"./es-do.js": 191,
	"./es-mx": 192,
	"./es-mx.js": 192,
	"./es-us": 193,
	"./es-us.js": 193,
	"./es.js": 194,
	"./et": 195,
	"./et.js": 195,
	"./eu": 196,
	"./eu.js": 196,
	"./fa": 197,
	"./fa.js": 197,
	"./fi": 198,
	"./fi.js": 198,
	"./fil": 199,
	"./fil.js": 199,
	"./fo": 200,
	"./fo.js": 200,
	"./fr": 203,
	"./fr-ca": 201,
	"./fr-ca.js": 201,
	"./fr-ch": 202,
	"./fr-ch.js": 202,
	"./fr.js": 203,
	"./fy": 204,
	"./fy.js": 204,
	"./ga": 205,
	"./ga.js": 205,
	"./gd": 206,
	"./gd.js": 206,
	"./gl": 207,
	"./gl.js": 207,
	"./gom-deva": 208,
	"./gom-deva.js": 208,
	"./gom-latn": 209,
	"./gom-latn.js": 209,
	"./gu": 210,
	"./gu.js": 210,
	"./he": 211,
	"./he.js": 211,
	"./hi": 212,
	"./hi.js": 212,
	"./hr": 213,
	"./hr.js": 213,
	"./hu": 214,
	"./hu.js": 214,
	"./hy-am": 215,
	"./hy-am.js": 215,
	"./id": 216,
	"./id.js": 216,
	"./is": 217,
	"./is.js": 217,
	"./it": 219,
	"./it-ch": 218,
	"./it-ch.js": 218,
	"./it.js": 219,
	"./ja": 220,
	"./ja.js": 220,
	"./jv": 221,
	"./jv.js": 221,
	"./ka": 222,
	"./ka.js": 222,
	"./kk": 223,
	"./kk.js": 223,
	"./km": 224,
	"./km.js": 224,
	"./kn": 225,
	"./kn.js": 225,
	"./ko": 226,
	"./ko.js": 226,
	"./ku": 227,
	"./ku.js": 227,
	"./ky": 228,
	"./ky.js": 228,
	"./lb": 229,
	"./lb.js": 229,
	"./lo": 230,
	"./lo.js": 230,
	"./lt": 231,
	"./lt.js": 231,
	"./lv": 232,
	"./lv.js": 232,
	"./me": 233,
	"./me.js": 233,
	"./mi": 234,
	"./mi.js": 234,
	"./mk": 235,
	"./mk.js": 235,
	"./ml": 236,
	"./ml.js": 236,
	"./mn": 237,
	"./mn.js": 237,
	"./mr": 238,
	"./mr.js": 238,
	"./ms": 240,
	"./ms-my": 239,
	"./ms-my.js": 239,
	"./ms.js": 240,
	"./mt": 241,
	"./mt.js": 241,
	"./my": 242,
	"./my.js": 242,
	"./nb": 243,
	"./nb.js": 243,
	"./ne": 244,
	"./ne.js": 244,
	"./nl": 246,
	"./nl-be": 245,
	"./nl-be.js": 245,
	"./nl.js": 246,
	"./nn": 247,
	"./nn.js": 247,
	"./oc-lnc": 248,
	"./oc-lnc.js": 248,
	"./pa-in": 249,
	"./pa-in.js": 249,
	"./pl": 250,
	"./pl.js": 250,
	"./pt": 252,
	"./pt-br": 251,
	"./pt-br.js": 251,
	"./pt.js": 252,
	"./ro": 253,
	"./ro.js": 253,
	"./ru": 254,
	"./ru.js": 254,
	"./sd": 255,
	"./sd.js": 255,
	"./se": 256,
	"./se.js": 256,
	"./si": 257,
	"./si.js": 257,
	"./sk": 258,
	"./sk.js": 258,
	"./sl": 259,
	"./sl.js": 259,
	"./sq": 260,
	"./sq.js": 260,
	"./sr": 262,
	"./sr-cyrl": 261,
	"./sr-cyrl.js": 261,
	"./sr.js": 262,
	"./ss": 263,
	"./ss.js": 263,
	"./sv": 264,
	"./sv.js": 264,
	"./sw": 265,
	"./sw.js": 265,
	"./ta": 266,
	"./ta.js": 266,
	"./te": 267,
	"./te.js": 267,
	"./tet": 268,
	"./tet.js": 268,
	"./tg": 269,
	"./tg.js": 269,
	"./th": 270,
	"./th.js": 270,
	"./tk": 271,
	"./tk.js": 271,
	"./tl-ph": 272,
	"./tl-ph.js": 272,
	"./tlh": 273,
	"./tlh.js": 273,
	"./tr": 274,
	"./tr.js": 274,
	"./tzl": 275,
	"./tzl.js": 275,
	"./tzm": 277,
	"./tzm-latn": 276,
	"./tzm-latn.js": 276,
	"./tzm.js": 277,
	"./ug-cn": 278,
	"./ug-cn.js": 278,
	"./uk": 279,
	"./uk.js": 279,
	"./ur": 280,
	"./ur.js": 280,
	"./uz": 282,
	"./uz-latn": 281,
	"./uz-latn.js": 281,
	"./uz.js": 282,
	"./vi": 283,
	"./vi.js": 283,
	"./x-pseudo": 284,
	"./x-pseudo.js": 284,
	"./yo": 285,
	"./yo.js": 285,
	"./zh-cn": 286,
	"./zh-cn.js": 286,
	"./zh-hk": 287,
	"./zh-hk.js": 287,
	"./zh-mo": 288,
	"./zh-mo.js": 288,
	"./zh-tw": 289,
	"./zh-tw.js": 289
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 537;

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 541:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4NCjxzdmcgd2lkdGg9IjE3NHB4IiBoZWlnaHQ9IjMxM3B4IiB2aWV3Qm94PSIwIDAgMTc0IDMxMyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4NCiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ2LjIgKDQ0NDk2KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4NCiAgICA8dGl0bGU+YXNzZXRzLXByb2R1Y3Rpb24tZG9iPC90aXRsZT4NCiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4NCiAgICA8ZGVmcz4NCiAgICAgICAgPGZpbHRlciB4PSItMzYuNyUiIHk9Ii0xNzQuNCUiIHdpZHRoPSIxNzMuNCUiIGhlaWdodD0iNDQ4LjglIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIGlkPSJmaWx0ZXItMSI+DQogICAgICAgICAgICA8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSIxMy45NTMzNTQ4IiBpbj0iU291cmNlR3JhcGhpYyI+PC9mZUdhdXNzaWFuQmx1cj4NCiAgICAgICAgPC9maWx0ZXI+DQogICAgPC9kZWZzPg0KICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPg0KICAgICAgICA8ZyBpZD0iYXNzZXRzLXByb2R1Y3Rpb24tZG9iIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4NCiAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsLTIiIGZpbGwtb3BhY2l0eT0iMC4zMzU2ODI3NDUiIGZpbGw9IiM2NTY1NjUiIGZpbHRlcj0idXJsKCNmaWx0ZXItMSkiIGN4PSI4NyIgY3k9IjI2OSIgcng9IjU3IiByeT0iMTIiPjwvZWxsaXBzZT4NCiAgICAgICAgICAgIDxwYXRoIGQ9Ik04Ni4zODEwMjI5LDI2NC42NjAxNjcgQzg2LjM4MTAyMjksMjY0LjY2MDE2NyAxMTEsMjEzLjAwMDAwNCAxNTMuNjc3NTExLDE0MiBDMTk2LjM1NTAyMiw3MC45OTk5OTU3IDE2Mi41OTYzMTYsLTAuMjMzOTI1ODE5IDg2LjM4MTAyMDcsLTAuMjMzOTI1ODE5IEMxMC4xNjU3MjUyLC0wLjIzMzkyNTgxOSAtMjIuNDMwMTM1MSw2NS43ODQ3MDQ1IDE1LjY3NzUxMzMsMTQyIEM1OS4xNzU3ODI0LDIxMi45OTgyNzYgODYuMzgxMDIyOSwyNjQuNjYwMTY3IDg2LjM4MTAyMjksMjY0LjY2MDE2NyBaIiBpZD0iT3ZhbC0xIiBmaWxsPSIjRUY1NTM0Ij48L3BhdGg+DQogICAgICAgICAgICA8aW1hZ2UgaWQ9Ik9pbC1SaWctRmlsbGVkLTEwMCIgeD0iMzciIHk9IjMyIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeGxpbms6aHJlZj0iZGF0YTppbWFnZS9wbmc7YmFzZTY0LGlWQk9SdzBLR2dvQUFBQU5TVWhFVWdBQUFHUUFBQUJrQ0FZQUFBQnc0cFZVQUFBQUJHZEJUVUVBQTF0ZVhQOG1lQUFBQjVWSlJFRlVlQUh0VysxeDR6WVV0RFA1SDViQURxSlVFSlNnRW5nZFhBZFdCM0Vxc0ZKQmZCVllWOEhwS3FDdWd0Z1ZPUHQwaEUyQ0FKWWdDWDRabU9FQWVGOTRiNWNFSk1xK3VVa3RJWkFRU0Fna0JCSUNDWUdFUUVJZ0lkQVpnZGZYMXgydWYzRkpLM0hkZFhaT2h1TWlBUEJ6WFAvaE10dGgzSlUrYURTZ2VvZXJ4Q1ZON3ZxZER3cm9qMkpvYWFYUEwrazZJQUJRRHhaZ1JXUWxCZkxNWVg4VmQxZ3ltZmdRQUlxbEErQW5teDlzOXc1N0VUL2FmSklzQUFFUHVLTEt6VkNRdVo2b2k4M2U5Sjk3L3N2Y0NYUlkvNnZIWm0vUktZdnNDMlM3Mjl2YmkwV1hSQ0VJNEs1V3VGenRhTWFDNGFsbS9JeHhZZHFrK1VBRUFLcWNDd0t1MlU1bWFCaVVsZEVaZlc3cTAzd2tCQUJ1aHV1K0FsdDMzOHp3bFVMSXlFeGRta2RBQUVETEZ2WmNBZjlxTGxIcEVoa21NREhuQUgySFN6NDEyUWl4SGZReDAwbXhCUUZ3a2VONlRtZ3NDQUVRVWl3b25ZK1hDZ2pJY1AyRnE4VEZXZ21EdTQrSDBvUVZBK0I3eG9KRmY1Z3d4WSsxRk1DMnZWSzNjTkFRbFd0Q2FRMnZUdXA0M3RZbkhjZDlmRHFHSHQ5c2JZVGM5NERnMk1NbnVYUkZBSnVSbkNQWDd5Q05qYWs5RVp0RDE3aExzVnZWNDF3SFRmQ3Z6ODB4M3V5dXNyYTFiVmttN3B1Ykw0b1EzUFR5N1Z0K002ZWZwaGdUaU5HbHlWbzdGbXRLL1dJZTZ3cVlKeFNmVFFrQTFwTFhMMzhzNWNlckpUMGhCd0F6TlJsWThycm12UXlXMEpiMGhIZ1A2ZGhnTGVWRHdDS2VFR3hYS2piZ0xQNFNjcEFjRjBFSTh0Z3h3Q2JRTHlHSFJFaU42RVJJRFl6ZmErTzVoa3ZJWWE3YW0rdGkvMll0YjNwY2Z6SDArbGpzNVdkZmJ6Tjk1cGpQZm9ZQUlVVUtmeG5qT3dKaW5MSE9pMit0RHJuNDNFZlJ6VTRJcW1CN3R3QTVWbU94V0M1ajVlR01zd1JDbERPN240b1QwWWVvV1N3VkVpeUc3UklJWVljcHU2dERjR0d4V0M0aGEvV3luWlVRN05rWnNzNUo1Z3hFNHQ1UXMxanljbE55bXEzTlNnaXEzcEhLUnpuUTlSclZod1B2d2Q0aEp4MHVTajgzSVlwVWRTTDZQbXIybEtnK1FjZnltWnNROW9RdzhQcmd3R0t5blBxc3VRNGY3TmNsTGw5VHJrcDhUcUt6K1VGY01EL29TNXZ2NW1Vb1hBNVExaklCQWtaN0V4RG1hTEh2UW9ZT201dittNThMeUxwNlIzOFJFS0RUeEJVeTE4M2g4eWJXZHRKREdFS0d4R2pkQVBWNE1jZHpuaUZzcno1WGhXdTdCd0UyRkl6SzV5SFFUNjhaNkRiY2ZFNUNGRW5mSkVUTSs1QmlJK003V1ZzUmZUVDFyOUVpODhEc1cvR3BDcUdNVUVLS0lRcWFmb0wxQmRlVHg0dmw1bkZkb1FxQTZuTUJRMmZMcERSb1EvZi9hMEFOaXhHOXFHSm1odHcyelhXTXpmZW9uaDNvZXJ1NllnSDdZRkkwaURXa0N5MlRIdkpMVFdjYjd1djJVNDNuT2tNVUtiQkJDRjU1SEdFdlcwM2Y5cW1LVWZjLzFTZVc4YzRpaXk2YWl4QldiSU1RUVdFQUtUWXlKR1JyRFJIV21xcU50ejIwN1ErR3pBa0c3RHB0WHd4QnhGSEdtcTBwaTdFSlBhb2UvTnMyWWxCU3VvRFZZcUF0WUU5eWwyV0NiT2JZc2xpUjdEdUMzcjZDQ25VWXM3VllybzZ3L2NWTEpJVHQ3ZjJyYlh1eXRSSWh3SXlCZENOYlZodmJYaEsyMXVTRTlLcGlpRk43bTI1SnZDQUlHUzBQaTZCTGpuRDcyQWY3VUFEZzM0a000VWNUSWo1NmJPdkZsalR2RFdLTE9VUTI5Um5DaXZ2cUtnYWdGZERaWGhTNlhMVDhvZkxWYzdOM3Jsa1pLdE1oNW54cGhKeHR4UTRnUTRmemtXSmRVenVpWnpkUnpYVDRjR3BDMkZ2VUZqZ2prS0ZSY3BIU1dsTTdWRDNMMlRCZjBSVGdzdGE0RzJIc09qTmM4cmY0R3BZM3dmdWcwRHJwSVI3OFJiVWVielZqRks3ZU1iR1A2c1hBd2dWNklYYjJDTzlTSGV0ZDBoaGRZeENidW9QU3RwdnBVZDNuZW9XVzhVa1hDNTJYRExHeitEZEVnYkZPRGVmMjVMT090NWtlTlQ2MjYyeElEbElzSlB1RzlIMVNpRjYzZDdGOXBPMmtoMFZodC9yNWtSaTZlNGRlaTQvMWVKc1lvN0pTVitmbzkxSW9kRWVMdmpCQnNOZzBSQlo3Snlsd2ROMEVPbVpweGx2MUhGVmx1akpQbjB1UjBIOHpiQXFSbTgyd2FVMU5lNW5EeUVYS29SV2dMY2hzTVZjcFEyMnFYVjlEOHF3TGEwZ0JvSmFidldIWG1wcjJlZzVERnltdEdJWkE2Umd4KzZtK2g3Qml6bElrQUtqYnVYN3BFOVBlYmNBdmo2cjNvZ0dPVXhHeUl6bWRLcjJxK2loa1ZMSDE3eW1odjlHekduVDQ1ZmU0ODB2ajhUZW5lNmtDd2tkY1JaZUt6QURtdkdPTWtPMXJHd2M3Z01wTnNDenpYQUNFWEVuZnBWbGlORVJkWW9nTm5FSkl5YnJHWGF3ZENtWWZLUzk5a20rZ2I1bUV4QXdnNWZva2g4UU90WjNpREdGNzd6azA2Ykh0QXc1NlZzdmcxS1lnUkpFc1p5ZEU4cXRJK1p2a3FvaCtzSG9LUXRqcjY5UGdLc1lMOEVoQ3NWcUlPMWRISlFSN2M0NFVNcExHSXA2UUtrZVdpN3h4a0pxaXRhaUVJT3NkeWZ3SHRvcG5Zak9adXNybEIxbVExVVRjL2VyWWhDai84dnhQZm9oL0REVjdTbFpOQ0V2K0ZBUFJnVEZaVG1wZ2ZLOTc3Q2ZrVCsvcUhmNG9qdmpIVUxNbmhOVVVJNmZoTVhINDdYQjUyNUJWdklHaGpCa2I0ZG1UMzN2NW1QOWpTSk1XVUh0blRoeGp4c2JTVWh0N2traUdkblhNTFlzU1lrOXBGZEpvdFNWQyt2RWY3Unk1N1pjUDk0cThaZkFFSWx2Z08wc1U3R0krSVpFaDJXYjRtSVI4MlNaazE2cWkxUmJsc1pPVXNXWGw2T1NUeUcrNHR0UmVVSXpDanJXdVQxbEkrSUxFNWRQSVA3aWtpQzAwcVNVYUdWc0FLTldRRUVnSUpBUVNBZ21CaEVCQ1lKa0kvQS92TkJPVmlXMTBVUUFBQUFCSlJVNUVya0pnZ2c9PSI+PC9pbWFnZT4NCiAgICAgICAgPC9nPg0KICAgIDwvZz4NCjwvc3ZnPg=="

/***/ }),

/***/ 542:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(530)
__webpack_require__(531)

var Component = __webpack_require__(291)(
  /* script */
  __webpack_require__(312),
  /* template */
  __webpack_require__(545),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(532)

var Component = __webpack_require__(291)(
  /* script */
  __webpack_require__(313),
  /* template */
  __webpack_require__(546),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "temporary": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": __webpack_require__(290)
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "app-title"
  }, [_vm._v("Assets for Sale")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "menu-chevron"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    staticClass: "app-menu-item",
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.assetManager),
      callback: function($$v) {
        _vm.assetManager = $$v
      },
      expression: "assetManager"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Assets")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.royaltyLayer),
      callback: function($$v) {
        _vm.royaltyLayer = $$v
      },
      expression: "royaltyLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Royalty\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#0085b1"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.productionLayer),
      callback: function($$v) {
        _vm.productionLayer = $$v
      },
      expression: "productionLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Production\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#ef5534"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": "",
      "disabled": !_vm.assetManager
    },
    model: {
      value: (_vm.landLayer),
      callback: function($$v) {
        _vm.landLayer = $$v
      },
      expression: "landLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("\r\n            Land\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#85a800"
    },
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("\r\n              stop\r\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.pipelineLayer),
      callback: function($$v) {
        _vm.pipelineLayer = $$v
      },
      expression: "pipelineLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Pipelines")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Oil\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#e41a1c"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Gas\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#4DAF4A"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Multiuse\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#377EB8"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    staticStyle: {
      "padding-left": "40px"
    },
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-title', [_vm._v("\r\n            Not Indentified\r\n          ")]), _vm._v(" "), _c('v-list-tile-avatar', [_c('v-icon', {
    staticStyle: {
      "color": "#984EA3"
    },
    attrs: {
      "large": ""
    }
  }, [_vm._v("\r\n              drag_handle\r\n            ")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "tag": "div"
    }
  }, [_c('v-list-tile-action', [_c('v-switch', {
    attrs: {
      "color": "primary",
      "light": ""
    },
    model: {
      value: (_vm.gridLayer),
      callback: function($$v) {
        _vm.gridLayer = $$v
      },
      expression: "gridLayer"
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Township Grid")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.tour()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Take a Tour")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "href": "mailto:customerservice@dobenergy.com",
      "target": "_blank"
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Get Help")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "app-toolbar white elevation-1",
    attrs: {
      "floating": "",
      "dense": ""
    }
  }, [_c('v-toolbar-side-icon', {
    staticClass: "app-menu-icon",
    attrs: {
      "light": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "app-search-box",
    attrs: {
      "prepend-icon": "search",
      "hide-details": "",
      "single-line": "",
      "placeholder": "Search for Assets"
    },
    on: {
      "input": _vm.onInput,
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.isOpen = false
      }
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), _c('v-dialog', {
    staticClass: "app-date-filter",
    attrs: {
      "lazy": "",
      "persistent": ""
    },
    model: {
      value: (_vm.dateDialog),
      callback: function($$v) {
        _vm.dateDialog = $$v
      },
      expression: "dateDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("access_time")])], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Filter by posting date")])]), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "padding": "0 16px"
    }
  }, [_c('v-btn', {
    staticClass: "blue-grey lighten-3 elevation-0 white--text",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByLastQuarter()
      }
    }
  }, [_vm._v("Last QTR")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue-grey lighten-3 elevation-0 white--text",
    attrs: {
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByThisQuarter()
      }
    }
  }, [_vm._v("This QTR")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.startDateMenu),
      callback: function($$v) {
        _vm.startDateMenu = $$v
      },
      expression: "startDateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "From",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.endDateMenu),
      callback: function($$v) {
        _vm.endDateMenu = $$v
      },
      expression: "endDateMenu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "To",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": "",
      "autosave": ""
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dateDialog = false, _vm.filterByDate()
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    staticClass: "app-table-view",
    attrs: {
      "lazy": "",
      "persistent": "",
      "fullscreen": "",
      "transition": "dialog-bottom-transition"
    },
    model: {
      value: (_vm.listDialog),
      callback: function($$v) {
        _vm.listDialog = $$v
      },
      expression: "listDialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("view_list")])], 1), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.listDialog = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v("List of Assets")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('v-card-title', [_c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.listSearch),
      callback: function($$v) {
        _vm.listSearch = $$v
      },
      expression: "listSearch"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.listDataTableHeaders,
      "items": _vm.assetData,
      "search": _vm.listSearch
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.area))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.asset_type))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.company))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "150px"
          }
        }, [_vm._v(_vm._s(props.item.agent))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          staticStyle: {
            "width": "200px"
          }
        }, [_vm._v(_vm._s(props.item.bid_date))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left",
          domProps: {
            "innerHTML": _vm._s(props.item.description)
          }
        })]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\r\n                From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\r\n            ")]
      }
    }])
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "app-search-tags"
  }, [_c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagCompany),
      callback: function($$v) {
        _vm.tagCompany = $$v
      },
      expression: "tagCompany"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("business")]), _vm._v("\r\n      " + _vm._s(_vm.selectedCompany) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagArea),
      callback: function($$v) {
        _vm.tagArea = $$v
      },
      expression: "tagArea"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("select_all")]), _vm._v("\r\n      " + _vm._s(_vm.selectedArea) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagAdvisor),
      callback: function($$v) {
        _vm.tagAdvisor = $$v
      },
      expression: "tagAdvisor"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("person")]), _vm._v("\r\n      " + _vm._s(_vm.selectedAdvisor) + "\r\n    ")], 1), _vm._v(" "), _c('v-chip', {
    staticClass: "primary white--text elevation-1 app-search-tag",
    attrs: {
      "close": ""
    },
    model: {
      value: (_vm.tagDate),
      callback: function($$v) {
        _vm.tagDate = $$v
      },
      expression: "tagDate"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("access_time")]), _vm._v("\r\n      " + _vm._s(_vm.selectedDate) + "\r\n    ")], 1)], 1), _vm._v(" "), _c('v-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "autocomplete-list elevation-1"
  }, [_vm._l((_vm.filteredItems), function(item, index) {
    return [(_vm.hasResults === true) ? _c('v-list-tile', {
      key: index,
      staticClass: "autocomplete-list-item",
      nativeOn: {
        "click": function($event) {
          _vm.select(index)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.value)
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (index < _vm.searchResult.length - 1) ? _c('v-divider') : _vm._e()]
  })], 2), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view', {
    attrs: {
      "name": "Map"
    }
  })], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.snackbarTimeout,
      "top": _vm.snackbarY === 'top',
      "bottom": _vm.snackbarY === 'bottom',
      "right": _vm.snackbarX === 'right',
      "left": _vm.snackbarX === 'left',
      "multi-line": _vm.snackbarMode === 'multi-line',
      "vertical": _vm.snackbarMode === 'vertical',
      "success": _vm.snackbarContext === 'success',
      "error": _vm.snackbarContext === 'error'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\r\n    " + _vm._s(_vm.snackbarText) + "\r\n    "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetsLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetData
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbar
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarContext
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarTimeout
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.snackbarText
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.townshipHighlightLayer
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 546:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "map"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.map
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetManager
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.assetsLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.dlsLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.pipelineLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.gridLayer
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.townshipHighlightLayer
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(294);
module.exports = __webpack_require__(293);


/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
    serverUrl: "https://www.dobenergy.com/geoserver/ows",
    pipelineLayerUrl: "https://www.dobenergy.com/geoserver/gwc/service/tms/1.0.0/jwn:pipeline@EPSG:900913@png/{z}/{x}/{-y}.png",
    provinceLayerUrl: "https://www.dobenergy.com/geoserver/gwc/service/tms/1.0.0/jwn:canada_bounds@EPSG:900913@png/{z}/{x}/{-y}.png"
};

/***/ })

},[550]);


// WEBPACK FOOTER //
// static/js/app.615b8d53bfd2c06da37b.js